import { useTranslation } from "react-i18next";
import { Spinner } from "@tellescope/design-system";
import type { SubmitPhase } from "./store";
import { useMemo } from "react";

interface EnduserFormWizardSubmittingScreenProps {
  submitPhase: Exclude<SubmitPhase, "idle">;
  uploadProgress: { completed: number; total: number };
}

export const EnduserFormWizardSubmittingScreen = ({
  submitPhase,
  uploadProgress,
}: EnduserFormWizardSubmittingScreenProps) => {
  const { t } = useTranslation("forms");
  const message = useMemo(() => {
    if (submitPhase === "submitting") return t("Submitting your responses...");
    if (uploadProgress.total > 1) {
      return t("Uploading file {{completed}} of {{total}}...", {
        completed: Math.min(uploadProgress.completed + 1, uploadProgress.total),
        total: uploadProgress.total,
      });
    }
    return t("Uploading your file...");
  }, [submitPhase, t, uploadProgress.completed, uploadProgress.total]);

  return (
    <div className="flex flex-col items-center justify-center p-8 h-full gap-1">
      <Spinner size="sm">{message}</Spinner>
      <p className="text-xs text-muted-foreground text-center">{t("Please keep this window open.")}</p>
    </div>
  );
};
